export default __webpack_public_path__ + "static/media/property_1021.5f06fe91.png";